import React from "react";

import { openCookiePreferences, useTranslation } from "utils";

import { EmptyStateCard, Flex } from "components";

export const MapCookieConsentReminder = () => {
  const { t } = useTranslation("global");

  return (
    <Flex align="center" justify="center" className="map-cookie-consent-reminder">
      <EmptyStateCard
        type="secondary"
        iconName="tabler/cookie"
        title={t("mapCookieConsent.title")}
        description={t("mapCookieConsent.description")}
        buttonText={t("mapCookieConsent.buttonText")}
        onButtonClick={openCookiePreferences}
        dataTestId="map-cookie-consent-reminder"
      />
    </Flex>
  );
};

export default MapCookieConsentReminder;
